<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="800">
        <v-card>
            <v-card-title><span class="headline">Feedback</span>
                <v-spacer/>
                <v-icon large color="red" @click="toggleDialogNewFeedback(false)">mdi-close</v-icon>
            </v-card-title>
            <v-container>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col></v-col>
                            <v-col cols="4"> 
                                <!-- FEEDBACK NUMBER -->
                                <v-text-field class="mb-1" label="フィードバック番号" hide-details readonly v-model="feedback.feedback_number" dense outlined></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <!-- CONTENT -->
                                <v-autocomplete class="mb-1" label="リクエスト内容" hide-details v-model="feedback.content" :items="requestContentList" dense outlined></v-autocomplete>
                            </v-col>
                            <v-col></v-col>
                        </v-row>
                        <v-row>
                            <v-col></v-col>
                            <!-- <v-col cols="4"> -->
                            <v-col cols="3">
                                <v-text-field
                                    class="mb-2"
                                    v-model="feedback.feedback_customer_code"
                                    label="お客様コード"
                                    outlined
                                    dense
                                    counter="12"
                                    maxlength="12">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    v-show="feedback.content == 'CAD依頼のキャンセル'"
                                    v-model="feedback.revision_number"
                                    class="mb-2"
                                    outlined
                                    hide-details
                                    dense
                                    label="図面番号"
                                    maxlength="5">
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-menu
                                    v-show="feedback.content == 'CAD依頼のキャンセル'"
                                    v-model="requestedMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto">

                                    <template v-slot:activator="{on, attrs }">
                                        <v-text-field
                                            v-show="feedback.content == 'CAD依頼のキャンセル'"
                                            v-model="feedback.requested_date"
                                            class="mb-2"
                                            outlined
                                            hide-details
                                            dense
                                            label="依頼日"
                                            v-bind="attrs"
                                            v-on="on">
                                        </v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-show="feedback.content == 'CAD依頼のキャンセル'"
                                        v-model="feedback.requested_date"
                                        @input="requestedMenu = false"
                                        >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    v-show="feedback.content == 'CAD依頼のキャンセル'"
                                    v-model="feedback.requested_time"
                                    @input="formatTime"
                                    class="mb-2"
                                    outlined
                                    hide-details
                                    dense
                                    maxlength="5"
                                    label="依頼日（HH:mm）">
                                </v-text-field>
                            </v-col>
                            <v-col></v-col>
                            <!-- <v-col></v-col>
                            <v-col></v-col> -->
                        </v-row>
                        <v-row>
                            <v-col></v-col>
                            <v-col cols="10" class="mt-n5">
                                <!-- CONCERN -->
                                <v-textarea label="依頼内容を入力してください。" v-model="feedback.concern" hide-details outlined dense rows="3"></v-textarea>
                            </v-col>
                            <v-col></v-col>
                        </v-row>
                        <v-row>
                            <v-col></v-col>
                            <v-col cols="9">
                                <v-file-input @change="fileChange(feedback.attachments)" multiple v-model="feedback.attachments" outlined dense></v-file-input>
                            </v-col>
                            <v-col cols="1">
                                <!-- NOTE : OLD CONDTION -->
                                <!-- <v-btn icon @click="saveFeedback" :disabled="feedback.content == 'CAD依頼のキャンセル' ?
                                                    (feedback.requested_date == null || feedback.requested_date == '' || (feedback.requested_time || '').length < 5 || feedback.requested_time === '') :
                                                    (feedback.feedback_customer_code == null || feedback.feedback_customer_code == '')"> 
                                    <v-icon color="primary" x-large>mdi-send</v-icon>
                                </v-btn> -->

                                <!-- NOTE - NEW CONDITION -->
                                <v-btn :loading="loading" icon @click="saveFeedback" :disabled="feedback.content == null || feedback.content == '' || feedback.concern == null || feedback.concern == '' || (feedback.content == 'CAD依頼のキャンセル' ?
                                        (feedback.requested_date == null || feedback.requested_date == '' || (feedback.requested_time || '').length < 5 || feedback.requested_time === '') :
                                        (feedback.feedback_customer_code == null || feedback.feedback_customer_code == ''))"> 
                                    <v-icon color="primary" x-large>mdi-send</v-icon>
                                </v-btn>

                                <!-- <v-col cols="1">
                                <v-btn icon @click="saveFeedback" :disabled="feedback.content == 'CAD依頼のキャンセル' ?
                                                    (feedback.requested_date == null || feedback.requested_date == '' || feedback.requested_time.length < 5 || feedback.requested_time == '') :
                                                    (feedback.feedback_customer_code == null || feedback.feedback_customer_code == '')"> 
                                    <v-icon color="primary" x-large>mdi-send</v-icon>
                                </v-btn>
                            </v-col> -->
                            </v-col>
                            <v-col></v-col>
                        </v-row>
                    </v-container>
                        <v-snackbar
                            class="custom-snackbar"
                            v-model="requiredSnackbar.show"
                            :color="requiredSnackbar.color"
                            centered
                            :timeout="snackTimeout"
                            elevation="5"
                            transition="scroll-y-transition"
                            >
                            <v-icon>{{ requiredSnackbar.icon }}</v-icon>
                            <strong>{{ requiredSnackbar.message }}</strong>
                        </v-snackbar>
                </v-card-text>
            </v-container>
        </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import moment from 'moment-timezone';
export default {
    props: {
        dialog: Boolean
    },
    data(){
        return {
            loading: false,
            // newly added line 10/10/25
            env: {
				response : process.env.MIX_ENV == 'local' ? 'response-local' : 'response',
				request : process.env.MIX_ENV == 'local' ? 'request-local' : 'request',
			},

            // requested
            Date : moment().format('YYYY-MM-DD'),
            // requestedDate : null,
            requestedMenu : false,
            // timeInput: '',

            attachments: [],
            requestContentList: [
                "CAD依頼システムエラー",
                "CAD依頼システムの改善提案",
                // "CAD依頼のキャンセル",
                "SRS(仕様検討ツール依頼システム)エラー",
                "SRS(仕様検討ツール依頼システムの)改善提案"
            ],
            replyStatus: [
                "ALL",
                "REPLIED",
                "NOT YET REPLIED"
            ],
            requiredSnackbar: {
                show: false,
                color: null,
                icon: null,
                message: null,
            },
            snackTimeout: 1800,
        }

    },
    mounted() {
        this.getFeedbackNumber();
    },
    computed:{
        ...mapState([
            'feedback',
            // 'cadRequestVersion',
            'rules',
        ]),

        // formattedTime: {
        //     get() {
        //         return this.timeInput;
        //     },

        //     set(newValue) {
        //         // Remove any non-digit characters and limit the length to 5 characters (HH:mm)
        //         const formattedValue = newValue.replace(/[^\d:]/g, '').slice(0, 5);

        //         // Insert colons if they are missing
        //         if (formattedValue.length >= 2 && formattedValue.indexOf(':') === -1) {
        //             const hh = formattedValue.slice(0, 2);
        //             const mm = formattedValue.slice(2);
        //             this.timeInput = `${hh}:${mm}`;
        //         } else {
        //             this.timeInput = formattedValue;
        //         }
        //     },
        // },

    },
    methods: {

        formatTime(){
            const newValue = this.feedback.requested_time.replace(/[^\d:]/g, '').slice(0, 5);

            if (newValue.length >= 2 && newValue.indexOf(':') === -1) {
                const hh = newValue.slice(0, 2);
                const mm = newValue.slice(2);
                this.feedback.requested_time = `${hh}:${mm}`;
            } else {
                this.feedback.requested_time = newValue;
            }

        },


        fileChange(tempVariable){
            this.attachments = [];
                if(tempVariable){
                    tempVariable.forEach(async (item) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(item);
                            reader.onloadend = () => {
                                this.attachments.push({
                                    data: reader.result,
                                    name: item.name,
                                });

                            };
                            

                        })
                }

        },
        async sendEmailNewFeedback(
            from,
            to,
            cc = null,
            bcc,
            message,
            customerCode,
            item,
            attachment
        ) {
            // const data = {
            // from: from,
            // to: to,
            // cc: cc,
            // bcc: null,
            // subject: `Cad Request System V2 New Feedback`,
            // message: message,
            // attachment: attachment || [],
            // };
            // console.log(data, "data")

            const data = {
                recipient_email: to[0],
                subject: 'This is just a test',
                content: message,
            }
            axios({
                method : "POST",
                url: "api/sendFeedbackEmail",
                data : data
            }).then((res) => {
                console.log(res.data);
            })

            // return 1;

            // fetch('https://n74xp2v17a.execute-api.ap-southeast-2.amazonaws.com/prod/api/SendEmailNiErica', {
            //     method: 'POST', // or 'GET', 'PUT', etc., depending on your use case
            //     body: JSON.stringify(data),
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     })
            //     .then(() => {
            //         return console.log('email sent');
            //     })
            //     .catch(error => {
            //         console.log(error)
            //     });
        },

        // sendEmailNotif( 
        //     from,
        //     to,
        //     cc,
        //     message,
        //     attachment
        // ){
        //     let obj = {
        //         from: 'cad-request-v2',
        //         senderEmail: from,
        //         to: to,
        //         cc: cc,
        //         subject: `CAD Request System V2 Feedback`,
        //         message: message,
        //         attachment: attachment,
        //     }

        //     axios({
        //         "method" : "POST",
        //         "url": "api/email-form",
        //         data: obj
        //     }).then((res) => {
        //         console.log(res.data)
        //     }).catch((err) => {
        //         console.log(err)
        //     })
        // },

        saveFeedback(){ //  
            this.loading = true;
            if(this.feedback.content == 'CAD依頼のキャンセル' && this.feedback.feedback_customer_code == null && this.feedback.revision_number != null && this.feedback.requested_date != null && this.feedback.requested_time != null) {
                this.requiredSnackbar = {
                    message: "Please input customer code!",
                    color: "red",
                    icon: "mdi-alert-circle",
                    show: true,
                };
                return false;
            } 
            else if(this.feedback.content == null && this.feedback.feedback_customer_code != null){
                this.requiredSnackbar = {
                    message: "Please input request content!",
                    color: "red",
                    icon: "mdi-alert-circle",
                    show: true,
                };
                return false;
            }
            else if(this.feedback.content == 'CAD依頼のキャンセル' && this.feedback.feedback_customer_code != null && this.feedback.revision_number == null && this.feedback.requested_date != null && this.feedback.requested_time != null) {
                this.requiredSnackbar = {
                    message: "Please input revision number!",
                    color: "red",
                    icon: "mdi-alert-circle",
                    show: true,
                };
                return false;
            }  else if(this.feedback.content == 'CAD依頼のキャンセル' && this.feedback.feedback_customer_code == null && this.feedback.revision_number == null && this.feedback.requested_date != null && this.feedback.requested_time != null) {
                this.requiredSnackbar = {
                    message: "Please input required fields!",
                    color: "red",
                    icon: "mdi-alert-circle",
                    show: true,
                }
            }
            else { // IF NOT SELECT CANCEL REQUEST(CAD依頼のキャンセル)
                var formdata = new FormData();
                formdata.append("files", JSON.stringify(this.attachments));
                formdata.append('data', JSON.stringify(this.feedback))
                // console.log('--- FormData Contents ---');
                // for (let pair of formdata.entries()) {
                //     console.log(pair[0] + ': ' + pair[1]);
                // }
                // console.log('--- End FormData Contents ---');
                axios({
                    method: "POST",
                    url: "api/saveFeedback",
                    data: formdata
                }).then(({data}) => {
                    this.sendEmail(this.feedback)
                    this.filterFeedback();
                    this.toggleDialogNewFeedback(false)
                    this.loading = false;
                    // let FeedbackCategory = this.feedback.content;
                    // let FeedbackNo = this.feedback.feedback_number;
                    // let concern = this.feedback.concern;
                    // let currentTimezone = moment.tz.guess(true);

                    // let tokyoTimezone = moment.tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss");
                    // let dateSent = currentTimezone == "Asia/Tokyo" ? tokyoTimezone : moment().format("YYYY-MM-DD HH:mm:ss");
                    // var message = `New feedback has been sent.
                    //     <br><p><b>Feedback Details: </b></p><p><b>依頼内容:  </b><span>   </span>${FeedbackCategory} </p><p><b>フィードバック番号:
                    //     </b><span>   </span>${FeedbackNo} </p><br><span>----------------------------------------------</span><p><b><p><b>FeedBack/Concern:  </b></p><p>${concern}</p><p><b>Date Replied: </b><span>   </span>${dateSent} (${currentTimezone})</p><p>
                    //     Please Check Cad Request System :
                    //     </p><a href="https://cadrequestv2.hrd-s.com/feedBack">Cad Request System V2.${this.$store.state.cadRequestVersion.version}</a><br><p><b>Thank You.<b/></p><p>*Please do not reply to this email. This is an auto-generated email.</p>`;
                    
                    // this.sendEmailNotif(
                    //     ["cad-requestv2@hrd-ihs.com"],
                    //     ["r-ladanan@hrd-s.com"],
                    //     ["r-quinto@hrd-s.com"],
                    //     message,
                    //     []
                    // );
                    this.$store.state.feedback = {};
                    this.attachments = [];

                })
            }
        },

        //NOTE - FUNCTION FOR SENDING EMAIL TO SPECIFIC PEOPLE
        sendEmail(feedback){
            console.log(feedback, 'check')
            const feedbackBy = this.$store.state.loggedInUser.name;
            const feedbackByEmail = this.$store.state.loggedInUser.email;
            const filename = this.$store.state.feedback.feedback_number;
            try {
            this.$socket.emit('newUpdate', {
                dispatchType: this.env.request,
                data: {
                    feedback,
                    feedbackBy,
                    feedbackByEmail,
                    filename
                },
                functionType: 'sendFeedbackEmail'
            });
            } catch (error) {
                console.log(error, 'socket error')
            }
        },

        filterFeedback(){
            this.$emit('filterFeedback')
        },
        getFeedbackNumber(){
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hour = now.getHours();
            const minute = now.getMinutes();
            const second = now.getSeconds();

            this.$store.state.feedback.feedback_number = `${year}${month}${day}-${hour}${minute}${second}`;
        },

        toggleDialogNewFeedback(value){
            this.$emit('toggleDialogNewFeedback', value)
        },
    },
    watch:{
        dialog(val){
            if(!val) this.$store.state.feedback = {}
            else this.getFeedbackNumber();
        },
        // '$store.state.feedback'(val){
        //     console.log(val)
        // }
    }
}
</script>